import { render } from "./IntentsTabsLayout.vue?vue&type=template&id=eb4207b6&scoped=true&lang=pug"
import script from "./IntentsTabsLayout.vue?vue&type=script&lang=js"
export * from "./IntentsTabsLayout.vue?vue&type=script&lang=js"

import "./IntentsTabsLayout.vue?vue&type=style&index=0&id=eb4207b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4207b6"]])

export default __exports__